import { Component, OnInit, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import { CollegeService, Student_scheduleid } from '../services/College_name.service';
import { ActivatedRoute, Router } from '@angular/router';
import {ChangePipe} from '../replace_function';

@Component({
  selector: 'app-questionpdfexport',
  templateUrl: './questionpdfexport.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./questionpdfexport.component.scss']
})



export class QuestionpdfexportComponent implements OnInit {
  //public products: any[] = products;
  correct: boolean;
  incorrect: boolean;
  student_id: Student_scheduleid = { user_id: '', schedule_id: '' }
  //route: any;
  //student_id: any;
  id: any;
  scheduleid: any;
  rollnumber: any;
  firstname: any;
  college_name: any;
  questions_ready: boolean;
  studentdata: any;
  currentYear: any = new Date().getFullYear()
  //router: any;


  constructor(private fs: CollegeService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    this.view_questions();
    }

  //get college details for selected student Id
  view_questions() {
    this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));
    this.student_id.user_id =  this.studentdata.user_id;
    this.student_id.schedule_id = this.studentdata.schedule_id;
    this.fs.Student_Schedule_Id(this.student_id).subscribe(
      (data) => {

        this.scheduleid = data.results;


        this.rollnumber = this.scheduleid[0].Roll_Number;
        this.firstname = this.scheduleid[0].First_Name + " " + this.scheduleid[0].Last_Name;
        this.college_name = this.scheduleid[0].College_Name;

        this.view_question_pdf();
      },
      err => {
        console.error(err);
      }
    );

  }

  view_question_pdf() {
    this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));

    this.student_id.schedule_id =  this.studentdata.schedule_id;
    this.student_id.user_id =  this.studentdata.user_id;
    this.fs.Questionpdf(this.student_id).subscribe(
      (data) => {

        this.scheduleid = data.results;


        this.student_id.user_id = this.id
        this.student_id.schedule_id = this.scheduleid[0].Id;
        for (var i = 0; i < this.scheduleid.length; i++) {
          MathJax.Hub.Config({
            showMathMenu: false,
            tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] },
            menuSettings: { zoom: "Double-Click", zscale: "150%" },
            CommonHTML: { linebreaks: { automatic: true } },
            "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
            SVG: { linebreaks: { automatic: true } }
          });
          setTimeout(() => {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
          }, 6000)

        }
        this.questions_ready = true;

      },
      err => {
        console.error(err);
      }
    );


  }
  back() {
    this.router.navigate(['/overall_result']);
  }
  convert() {
    for (var i = 0; i < this.scheduleid.length; i++) {
      MathJax.Hub.Config({
        showMathMenu: false,
        tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] },
        menuSettings: { zoom: "Double-Click", zscale: "150%" },
        CommonHTML: { linebreaks: { automatic: true } },
        "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
        SVG: { linebreaks: { automatic: true } }
      });
      setTimeout(() => {
        MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
      }, 3000)
    }
  }
}

/*@Pipe({name: 'replace'})
export class ReplacePipe implements PipeTransform {
  transform(value: string): string {
    if(!!value){
      let newValue = value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return `${newValue}`;
    }
  }
}*/
export var replace=new ChangePipe();